// extracted by mini-css-extract-plugin
export default {"content-config":"TabBar_content-config__K-ad6","controller":"TabBar_controller__DybA0","button-control":"TabBar_button-control__KYQDl","button-active":"TabBar_button-active__ENvz3"};